import { render, staticRenderFns } from "./SupportRoute.vue?vue&type=template&id=30954ff4&scoped=true"
import script from "./SupportRoute.vue?vue&type=script&lang=ts"
export * from "./SupportRoute.vue?vue&type=script&lang=ts"
import style0 from "./SupportRoute.vue?vue&type=style&index=0&id=30954ff4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30954ff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30954ff4')) {
      api.createRecord('30954ff4', component.options)
    } else {
      api.reload('30954ff4', component.options)
    }
    module.hot.accept("./SupportRoute.vue?vue&type=template&id=30954ff4&scoped=true", function () {
      api.rerender('30954ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SupportRoute.vue"
export default component.exports